import { render, staticRenderFns } from "./RecPointSetting.vue?vue&type=template&id=c1550106&scoped=true"
import script from "./RecPointSetting.vue?vue&type=script&lang=js"
export * from "./RecPointSetting.vue?vue&type=script&lang=js"
import style0 from "./RecPointSetting.vue?vue&type=style&index=0&id=c1550106&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1550106",
  null
  
)

export default component.exports